export default __webpack_public_path__ + "static/media/check_icon.efe08266.svg";